import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'
import { Card as YogaCard, List as YogaList, Button } from '@gympass/yoga'
import { H2, H3, H5, H6 } from '@components/Text'

export const MainWrapper = styled.section`
  padding-top: 80px;
  padding-bottom: 96px;
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 32px;
  font-family: Rubik;
`

export const Subtitle = styled(H5)`
  font-weight: 500;
  line-height: 21px;
  color: var(--secondary-text);
  margin-top: 8px;
  strong {
    font-weight: 900;
  }
  font-family: Rubik;
`

export const Card = styled(YogaCard)`
  padding: 0;
  margin-top: 48px;
  border-radius: 16px;
  margin-bottom: 90px;
`

export const List = styled(YogaList)`
  padding: 12px 16px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    padding: 20px 16px;
  }
`

export const ListItem = styled(YogaList.Item)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ItemDescription = styled(H6)`
  font-weight: normal;
  line-height: 19px;
  font-family: Rubik;
`

export const LinkButton = styled(Button.Link)`
  display: flex;
  align-items: center;
  margin: 0;
`

export const LinkButtonText = styled(Button.Link)`
  font-weight: 700;
  margin-left: 8px;
`

export const ShareWrapper = styled.section`
  margin-top: 32px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 54px;
  }
`

export const Form = styled.section`
  display: flex;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #dce0ed;
  padding: 8px;
  margin-top: 24px;
  margin-bottom: 56px;
`

export const ShareLink = styled.span`
  overflow: hidden;
  max-height: 20px;
  text-overflow: ellipsis;
  margin-left: 10px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-right: 24px;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 700;
  font-family: Rubik;
`

export const LinkText = styled.span`
  color: #d8385e;
  margin-left: 5px;
  font-family: Rubik;
`

export const UsefulInfo = styled(H3)`
  margin-top: 80px;
  font-weight: 900;
  line-height: 32px;
  font-family: Rubik;
`

export const UsefulInfoSub = styled(H5)`
  font-weight: 500;
  line-height: 21px;
  color: var(--secondary-text);
  margin-top: 8px;
  strong {
    font-weight: 900;
  }
  font-family: Rubik;
`

export const CopyLinkDescription = styled(H6)`
  line-height: 19px;
  font-family: Rubik;
`

export const CopyLinkWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: 100px;
  width: 100%;
`

export const InputWrapper = styled.section`
  width: 100%;
  height: 100%;

  input:disabled {
    background: white;
  }
`

export const Input = styled.input`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  padding: 0 24px;
  border: none;
  outline: 0;
  border-radius: 100px;

  text-overflow: ellipsis;
  overflow: hidden;
  width: 269px;
  margin-top: 12px;
`

export const CopyLinkButton = styled(Button)`
  background: #001027;
  border: 1px solid #001027;
  &:hover {
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:focus {
    opacity: 0.75;
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:active {
    opacity: 0.75;
    background: #231b22;
  }
`

export const CopyLinkForm = styled.section`
  display: flex;
  border-radius: 100px;
  border: 1px solid #dce0ed;
  padding: 8px;
  margin-top: 24px;
  background: white;
`

export const BackLinkButton = styled(Button.Link)`
  display: flex;
  align-items: center;
  margin-top: 50px;
`

export const Disclaimer = styled.section`
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 22px;
  color: #6b6b78;
  margin-left: 10px;
`
